'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import PropTypes from 'prop-types';
import { getReport } from 'dashboard-lib/public/widget/widget-schema';
import { getEventValue } from 'reporting-action-components/utils/jsEventUtils';
import { DEFAULT_EXPORT_TYPE, DATA_EXPORT_TYPES, EXPORT_TYPES_FOR_DASHBOARD, IMAGE_EXPORT_TYPES } from 'reporting-action-components/reportingActions/shared/emailLogic';
import { isUnsupportedDataExportType } from 'reporting-action-components/reportingActions/shared/emailLogic';
import useExportReportProblem from 'reporting-action-components/reportingActions/exportReport/useExportReportProblem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DATA_EXPORT = 'Data export';
const IMAGE_EXPORT = 'Image export';
const getDataExportOptions = (dataExportTypes, allSupportedReports = true) => Object.keys(dataExportTypes).map(exportType => {
  return {
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `email.dashboard.prompt.exportType.${exportType.toLowerCase()}`
    }),
    value: exportType,
    disabled: !allSupportedReports
  };
});
const getDataExportOptionList = allSupportedReports => {
  const allDataExportOptions = [{
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `email.dashboard.prompt.exportType.${DEFAULT_EXPORT_TYPE.NONE.toLowerCase()}`
    }),
    value: DEFAULT_EXPORT_TYPE.NONE
  }, {
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `email.dashboard.prompt.visualDataExportGroupTitle`
    }),
    value: IMAGE_EXPORT,
    options: getDataExportOptions(IMAGE_EXPORT_TYPES)
  }, {
    text: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `email.dashboard.prompt.dataExportGroupTitle`
      }), !allSupportedReports && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', /*#__PURE__*/_jsx(UIHelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "export.email.tooltip"
          })
        })]
      })]
    }),
    value: DATA_EXPORT,
    options: getDataExportOptions(DATA_EXPORT_TYPES, allSupportedReports)
  }];
  return allDataExportOptions;
};
const ExportTypeOptionsSelect = ({
  setExportType,
  exportType,
  dashboard
}) => {
  const exportReportProblem = useExportReportProblem;
  const checkAllReportsUnsupportedDataExport = dashboard.get('widgets').map(widget => {
    const {
      problem
    } = exportReportProblem({
      report: getReport(widget),
      hasLimitedReportTypeSupport: true
    });
    return !problem;
  })
  // we are using .indexOf instead of .every because when the function finds 'false' value, it exits out the function causing the hooks to render inconsistently
  .indexOf(true) !== -1;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "export.email.fileType"
        }), ' ']
      }),
      children: /*#__PURE__*/_jsx(UISelect, {
        onChange: e => setExportType(getEventValue(e)),
        options: getDataExportOptionList(checkAllReportsUnsupportedDataExport),
        value: exportType,
        "data-test-id": "email-dashboard-data-export"
      })
    }), isUnsupportedDataExportType(exportType) && /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email.dashboard.unsupportedDataExportLabel"
      })
    })]
  });
};
ExportTypeOptionsSelect.propTypes = {
  setExportType: PropTypes.func.isRequired,
  exportType: PropTypes.oneOf(Object.values(EXPORT_TYPES_FOR_DASHBOARD)).isRequired,
  dashboard: PropTypes.object.isRequired
};
export default ExportTypeOptionsSelect;